export default "__VITE_ASSET__4029501b__"